import axios from "axios";
import * as XLSX from "xlsx-js-style";

export async function addressToLatLng(address) {
  try {
    const response = await axios.get(
      "https://maps.googleapis.com/maps/api/geocode/json",
      {
        params: {
          address: address,
          key: "AIzaSyDli8luQtXdHmh8iU566z8QQJqVQhBLSis",
        },
      }
    );

    if (response.data.status === "OK") {
      const location = response.data.results[0].geometry.location;
      return location; // { lat: <latitude>, lng: <longitude> }
    } else {
      throw new Error("Geocoding failed: " + response.data.status);
    }
  } catch (error) {
    console.error("Error occurred while geocoding:", error);
    throw error;
  }
}

export function wrapLastTextInBracketsWithStrong(text) {
  const lastBracketIndex = text.lastIndexOf("(");
  if (lastBracketIndex !== -1) {
    const endBracketIndex = text.indexOf(")", lastBracketIndex);
    if (endBracketIndex !== -1) {
      const textBefore = text.substring(0, lastBracketIndex);
      const textInside = text.substring(lastBracketIndex, endBracketIndex + 1);
      const textAfter = text.substring(endBracketIndex + 1);
      return (
        <p>
          {textBefore}
          <strong>{textInside}</strong>
          {textAfter}
        </p>
      );
    }
  }
  return text;
}

export function exportFileToExcel(data, fileName) {
  const workbook = XLSX.utils.book_new();

  const borderStyle = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  const sanitizeSheetName = (name) => {
    const base = (name || "Report").toString();
    // Excel constraints: max 31 chars, cannot contain: : \ / ? * [ ]
    const cleaned = base.replace(/[:\\/?*\[\]]/g, " ").trim() || "Report";
    return cleaned.slice(0, 31);
  };

  const buildWorksheet = (aoa) => {
    const safeData =
      Array.isArray(aoa) && aoa.length > 0 ? aoa : [[""]];
    const worksheet = XLSX.utils.aoa_to_sheet(safeData);

    // Calculate column widths based on content length (based on first row col count)
    const firstRow = safeData[0] || [];
    const colWidths = firstRow.map((_, colIndex) => {
      const maxLength = Math.max(
        ...safeData.map((row) =>
          row && row[colIndex] != null ? row[colIndex].toString().length : 0
        )
      );
      return { wch: maxLength + 6 };
    });
    worksheet["!cols"] = colWidths;

    // Apply wrap + borders to all present cells
    const range = worksheet["!ref"]
      ? XLSX.utils.decode_range(worksheet["!ref"])
      : null;
    if (range) {
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cell_ref = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cell_ref]) continue;
          const existingStyle = worksheet[cell_ref].s || {};
          worksheet[cell_ref].s = {
            ...existingStyle,
            alignment: {
              ...existingStyle.alignment,
              wrapText: true,
              vertical: "center",
              horizontal: "left",
            },
            border: { ...existingStyle.border, ...borderStyle },
          };
        }
      }
    }

    return worksheet;
  };

  // Backward compatible:
  // - existing callers pass Array<Array<any>> for a single worksheet
  // - new callers can pass { [sheetName]: Array<Array<any>> } for multi-sheet export
  const isMultiSheet =
    data &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    Object.keys(data).length > 0;

  if (isMultiSheet) {
    Object.entries(data).forEach(([sheetName, sheetData], idx) => {
      const worksheet = buildWorksheet(sheetData);
      const name = sanitizeSheetName(sheetName || `Report ${idx + 1}`);
      XLSX.utils.book_append_sheet(workbook, worksheet, name);
    });
  } else {
    const worksheet = buildWorksheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
  }

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}

export const priorityColors = {
  EMERGENCY: "rgb(247, 40, 40)",
  MULTIPLE: "rgb(246 239 221 / 61%)",
  PRIORITY: "orange",
  "PROJECT WORK": "#0073ba",
  STANDARD: "gray",
  "PRIORITY 0": "orange",
};
